import {
    ExternalLink,
    RowButton,
    useColors,
} from "@mallardbay/lib-react-components"
import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons/faLocationArrow"

import { getGoogleMapsDirectionsUrl } from "~utils/navigation-helpers"
import COPY from "~config/copy-constants"
interface Props {
    readonly address: string
}

const ICON_SIZE = 20

export default function GetDirectionsButton({ address }: Props) {
    const colors = useColors()
    const googleMapsDirectionsUrl = getGoogleMapsDirectionsUrl(address)

    return (
        <ExternalLink href={googleMapsDirectionsUrl}>
            <RowButton
                leftIcon={
                    <FontAwesomeIcon
                        icon={faLocationArrow}
                        fontSize={ICON_SIZE}
                        color={colors.brandColor}
                    />
                }
            >
                {COPY.GET_DIRECTIONS}
            </RowButton>
        </ExternalLink>
    )
}
